import type { PageOrSubPageKey } from '@omnia/ui/src/lib'
import { BaseSubPageKey } from '@omnia/ui/src/lib'
import type { PageList } from '@omnia/ui/src/lib/services/models/pagelist-models'
import { BasePagesEnum } from '@omnia/ui/src/lib/services/models/pagelist-models'

export class PagesEnum extends BasePagesEnum {
    public Home = 'Home'
    public Generic = 'Generic'
    public Films = 'Films'
    public FilmDetails = 'FilmDetails'
    public Cinemas = 'Cinemas'
    public Cinema = 'Cinema'
    public Events = 'Events'
    public EventDetails = 'EventDetails'
    public Account = 'Account'
}

export class AccountSubPages extends BaseSubPageKey<PagesEnum> {
    public parent: keyof PagesEnum = 'Account'
    public AccountOverview = 'AccountOverview'
    public AccountBookings = 'AccountBookings'
    public AccountWatchlist = 'AccountWatchlist'
    public AccountMembership = 'AccountMembership'
    public AccountDetails = 'AccountDetails'
    public AccountPaymentCards = 'AccountPaymentCards'
    public AccountProfile = 'AccountProfile'
    public AccountCompleteProfile = 'AccountCompleteProfile'
}

export class TicketingSubPages extends BaseSubPageKey<PagesEnum> {
    public parent: keyof PagesEnum = 'Ticketing'
    public SeatPicker = 'SeatPicker'
    // public TicketPicker = 'TicketPicker'
    // public TicketingLogin = 'TicketingLogin'
    // public OrderSummary = 'OrderSummary'
    // public OrderPayment = 'OrderPayment'
    // public Concessions = 'Concessions'
}

export type PagesType = PageList<PagesEnum, SubPagesType>
export type SubPagesType = AccountSubPages & TicketingSubPages

export type AllPagesKeys = PageOrSubPageKey<PagesEnum, AccountSubPages | TicketingSubPages>
export type PagesKeys = keyof PagesEnum
export type SubPageKeys = keyof SubPagesType
